import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { CANCELLED, DECLINED_CANCELLED, RETURNED, RETURNING } from 'constants/orderStatuses';

import MartyLink from 'components/common/MartyLink';
import styles from 'styles/components/account/orderItemImage.scss';

const makeItemStatus = status => {
  if (status) {
    status = status.toLowerCase();
    if (status === RETURNING) {
      return <span className={styles.returned}>Returning</span>;
    } else if (status === RETURNED) {
      return <span className={styles.returned}>Returned</span>;
    } else if (status === CANCELLED || status === DECLINED_CANCELLED) {
      return <span className={styles.cancelled}>Cancelled</span>;
    }
  } else {
    return null;
  }
};

const OrderItemImage = ({ title, imageUrl, status, url }, { testId }) => {
  const itemStatus = makeItemStatus(status);

  if (url) {
    return (
      <MartyLink
        to={url}
        className={styles.mProduct}
        itemScope
        itemType="http://schema.org/Product"
        tabIndex={0}
        data-test-id={testId('orderItemImage')}>
        <div className={cn(styles.image, { [styles.translucent]: Boolean(itemStatus) })}>
          {itemStatus}
          <img src={imageUrl} alt={title} title={title}/>
        </div>
      </MartyLink>
    );
  } else {
    return (
      <article className={styles.mProduct} itemScope itemType="http://schema.org/Product">
        <div className={cn(styles.image, { [styles.translucent]: Boolean(itemStatus) })}>
          {itemStatus}
          <img src={imageUrl} alt={title} title={title}/>
        </div>
      </article>
    );
  }
};

OrderItemImage.contextTypes = {
  testId: PropTypes.func
};

OrderItemImage.propTypes = {
  title: PropTypes.string.isRequired,
  imageUrl: PropTypes.string.isRequired,
  status: PropTypes.string,
  url: PropTypes.string
};

export default OrderItemImage;
